import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

export const useCallRecording = (show, onMuteCall, onResumeCall) => {
  const [isCallMuted, setIsCallMuted] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const hasPhoneExtension = user.data.attributes?.metadata?.phone_extension;

  useEffect(
    () => {
      if (!hasPhoneExtension) {
        return;
      }

      if (show && !isCallMuted) {
        onMuteCall();
        setIsCallMuted(true);
      }
      if (!show && isCallMuted) {
        onResumeCall();
        setIsCallMuted(false);
      }
    },
    [show, isCallMuted, hasPhoneExtension, onMuteCall, onResumeCall],
  );
};
